import { each, go, map, unique } from 'fxjs/es';
import { $closest, $delegate, $find, $findAll, $hasClass, $hide, $qs, $show } from 'fxdom/es';
import { NessCoreConstantS } from '../../../Ness/Core/S/Constant/module/NessCoreConstantS.js';
import {
  clearTimers,
  getProductListType,
  initComingSoonRemainingTimer,
  initProductListSortDropdown,
  reRenderProductList,
} from '../../../Ness/App/Plus/Product/F/Function/product.js';
import { NessProductListType } from '../../../Ness/App/Plus/Product/S/Constant/product.js';
import { NESS_CUSTOM_USER_PRODUCT_LIST_URL } from '../../../Ness/S/Constant/custom.js';
import axios from 'axios';
import { NessOutboundF } from '../../../Ness/Outbound/F/Function/module/NessOutboundF.js';
import { NessInboundF } from '../../../Ness/Inbound/F/Function/module/NessInboundF.js';
import { UtilF } from '../../../Util/F/Function/module/UtilF.js';

const getSelectedCategories = (element) => {
  const getCategory = (is_cate_list_id) =>
    go(
      element,
      $closest('.ness-plus-product-list__cate-lists__custom'),
      $find(`.custom__category__item${is_cate_list_id ? '.category' : ''}.selected`),
    );

  const folder = getCategory(false);
  const category = getCategory(true);

  return {
    folder_name: folder?.dataset.custom_image_folder_name,
    cate_list_id: category?.dataset.id,
  };
};

const updateCategoryVisibility = (cate_list_ids) => {
  go(
    $qs('.custom__category.category_list'),
    $findAll('.custom__category__item'),
    each((category) => {
      const { id } = category.dataset;
      if (id === 'all') return;

      cate_list_ids.includes(id) ? $show(category) : $hide(category);
    }),
  );
};

const hideEmptyCategoriesForFolder = (element, folder_name) => {
  const has_product_cate_list_ids = go(
    element,
    $closest('.ness-plus-product-list'),
    $findAll(
      `.ness-plus-product-list__products .app-product-item--NESS[data-custom_image_folder_name="${folder_name}"]`,
    ),
    map((product) => product.dataset.cate_list_id),
    unique,
  );

  updateCategoryVisibility(has_product_cate_list_ids);
};

const showAllCategories = () =>
  go($qs('.custom__category.category_list'), $findAll('.custom__category__item'), each($show));

const hideEmptyCategories = (element) => {
  if ($hasClass('category', element)) return;

  const { custom_image_folder_name } = element.dataset;

  if (custom_image_folder_name === 'all') return showAllCategories();

  hideEmptyCategoriesForFolder(element, custom_image_folder_name);
};

export const handleProductFiltering = (element) => {
  if (!element) return;
  const { folder_name, cate_list_id } = getSelectedCategories(element);
  const search_params = new URLSearchParams(window.location.search);
  search_params.set('custom_image_folder_name', folder_name);
  search_params.set('cate_list_id', cate_list_id);
  return (window.location.href = `${window.location.pathname}?${search_params.toString()}`);
};

let remaining_timers = [];
export const nessCustomLabsEvents = (frame_el) => {
  const component = 'ness-plus-product-list';
  const component_el = $qs(`.${component}`, frame_el);

  const resetEls = (els) => {
    each((el) => {
      el.dataset.active = 'false';
      el.dataset.selected = 'false';
    }, els);
  };
  const setElActive = (el) => {
    el.dataset.active = 'true';
    el.dataset.selected = 'true';
  };

  const fetch_products_url = {
    all: `/${T.lang}/@api/renewal/product/list/all`,
    recent: `/${T.lang}/@api/renewal/product/list/recent`,
    limit: `/${T.lang}/@api/renewal/product/list/limit`,
    popular: `/${T.lang}/@api/renewal/product/list/popular`,
  };

  $delegate(
    'click',
    `.${NessCoreConstantS.layout_components.bottom_header_category}__menu`,
    async function handleCateListChange(e) {
      const { currentTarget: selected_cate_list_el } = e;
      const { cate_list_id } = e.currentTarget.dataset;
      const cate_list_els = $findAll(
        `.${NessCoreConstantS.layout_components.bottom_header_category}__menu`,
        frame_el,
      );
      resetEls(cate_list_els);
      setElActive(selected_cate_list_el);

      const product_list_type = getProductListType(cate_list_id);
      if (product_list_type === NessProductListType.labs) {
        return (window.location.href = NESS_CUSTOM_USER_PRODUCT_LIST_URL());
      }
      if (product_list_type === NessProductListType.all) {
        return (window.location.href = `/kr/@/product/list/all?cate_list_id=${cate_list_id}`);
      }
      return (window.location.href = `/kr/@/product/list/${product_list_type}`);
    },
  )(frame_el);
  NessOutboundF.initTopArrowButton();

  // filter initialize
  const resetSelectedEls = (els) => map((el) => (el.dataset.selected = 'false'), els);
  const selectEl = (el) => (el.dataset.selected = 'true');

  const cate_item_els = $findAll(`.${component}__cate-item`, frame_el);
  const limited_filter = $qs(`.${component}__limited-filter`, frame_el);
  const soldout_filter = $qs(`.${component}__soldout-filter`, frame_el);

  const product_list_type = component_el.dataset.type;

  // 특별판매만 보기
  NessInboundF.initCheckbox({
    target_el: limited_filter,
    hooks: {
      async onChange(e, is_checked, filter_key) {
        const component_el = $qs(`.${component}`, frame_el);
        const params = UtilF.parseUrlParams();
        const {
          data: { products },
        } = await axios.get(fetch_products_url[component_el.dataset.type], {
          params: {
            ...params,
            [filter_key]: is_checked,
          },
        });
        reRenderProductList(products);
        clearTimers(remaining_timers);
        remaining_timers = initComingSoonRemainingTimer(frame_el);
        history.replaceState(null, '', UtilF.updateUrlParams({ [filter_key]: is_checked }));
      },
    },
  });

  // 품절상품 제외
  NessInboundF.initCheckbox({
    target_el: soldout_filter,
    hooks: {
      async onChange(e, is_checked, filter_key) {
        const component_el = $qs(`.${component}`, frame_el);
        const params = UtilF.parseUrlParams();
        const {
          data: { products, metadata },
        } = await axios.get(fetch_products_url[component_el.dataset.type], {
          params: {
            ...params,
            [filter_key]: is_checked,
          },
        });
        reRenderProductList(products);
        clearTimers(remaining_timers);
        remaining_timers = initComingSoonRemainingTimer(frame_el);
        history.replaceState(null, '', UtilF.updateUrlParams(metadata));
      },
    },
  });
  // cate-item 변경
  // 신상품, 한정판, 인기 상품은 cate-item이 없음
  go(
    frame_el,
    $delegate('click', `button.${component}__cate-item`, async function handleCateItemChange(e) {
      const cate_item_el = e.currentTarget;
      const cate_list_id = cate_item_el.dataset.cate_list;

      const cur_params = UtilF.parseUrlParams();
      const new_params = (function getSelectedParams() {
        const value = cate_item_el.dataset.id == 'all' ? undefined : cate_item_el.dataset.id;
        return value
          ? { ...cur_params, cate_list_id, cate_item_id: value }
          : {
              ...cur_params,
              cate_list_id,
              cate_item_id: null,
            };
      })();

      resetSelectedEls(cate_item_els);
      selectEl(cate_item_el);

      const {
        data: { products },
      } = await axios.get(fetch_products_url.all, { params: new_params });
      history.replaceState(null, '', UtilF.updateUrlParams(new_params));
      reRenderProductList(products);
      clearTimers(remaining_timers);
      remaining_timers = initComingSoonRemainingTimer(frame_el);
    }),
  );
  initProductListSortDropdown(product_list_type);

  NessInboundF.delegateUpdateProductLike(frame_el);
  remaining_timers = initComingSoonRemainingTimer(frame_el);
};
